import React from 'react'
// import WhenInView from '../WhenInView'
// import ImageSlider from '../ImageSlider'

import './styles.scss'
import kugelTiefSVG from '../../assets/kugel-tiefe-lagen.svg'
import kugelMittelSVG from '../../assets/kugel-mittlere-lagen.svg'
import KugelHochSVG from '../../assets/kugel-hohe-lagen'
import styled from 'styled-components'
import kugelDeckelSVG from '../../assets/kugel-deckel.svg'
import SnowAnimator from 'components/Snow/SnowAnimator'
const SnowAnimationContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  /* background-color: green; */
  mask-image: url(${({ maskImage }) => maskImage});
  mask-repeat: no-repeat;
  mask-size: contain;
`
const SnowAnimation = styled.div``

export default class DeviceSwitch extends React.Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {}
  render() {
    // if (window.matchMedia('(min-width: 1px)').matches) {
    return (
      <div className='grid'>
        <div className='coverContent'>
          <div className='coverTextWrapper tief'>
            <div className='coverProzent tief'>{this.props.languageContent.tiefeLagen.percent}</div>
            <div className='coverText tief'>{this.props.languageContent.tiefeLagen.unit}</div>
            <div className='triangle tief'></div>
          </div>
          <div className='animation-container-cover'>
            <SnowAnimationContainer maskImage={kugelDeckelSVG}>
              <SnowAnimator snowflakeCount={50} />
            </SnowAnimationContainer>
            <img src={kugelTiefSVG} alt='Schneekugel' />
          </div>
          <div className='coverBylineWrapper'>
            <div className='category tief'>{this.props.languageContent.tiefeLagen.title}</div>
            <div className='altimeter tief'>{this.props.languageContent.tiefeLagen.altitude}</div>
          </div>
        </div>

        <div className='coverContent'>
          <div className='coverTextWrapper mittel'>
            <div className='coverProzent mittel'>{this.props.languageContent.mittlereLagen.percent}</div>
            <div className='coverText mittel'>{this.props.languageContent.mittlereLagen.unit}</div>
            <div className='triangle mittel'></div>
          </div>
          <div className='animation-container-cover'>
            <SnowAnimationContainer maskImage={kugelDeckelSVG} className={'mittel'}>
              <SnowAnimator snowflakeCount={120} />
            </SnowAnimationContainer>
            <img src={kugelMittelSVG} alt='Schneekugel' />
          </div>
          <div className='coverBylineWrapper'>
            <div className='category mittel'>{this.props.languageContent.mittlereLagen.title}</div>
            <div className='altimeter mittel'>{this.props.languageContent.mittlereLagen.altitude}</div>
          </div>
        </div>

        <div className='coverContent'>
          <div className='coverTextWrapper hoch'>
            <div className='coverProzent hoch'>{this.props.languageContent.hoheLagen.percent}</div>
            <div className='coverText hoch'>{this.props.languageContent.hoheLagen.unit}</div>
            <div className='triangle hoch'></div>
          </div>
          <div className='animation-container-cover'>
            <SnowAnimationContainer maskImage={kugelDeckelSVG} className={'hoch'}>
              <SnowAnimator snowflakeCount={220}/>
            </SnowAnimationContainer>
            <KugelHochSVG />
          </div>
          <div className='coverBylineWrapper'>
            <div className='category hoch'>{this.props.languageContent.hoheLagen.title}</div>
            <div className='altimeter hoch'>{this.props.languageContent.hoheLagen.altitude}</div>
          </div>
        </div>
      </div>
    )
    // } else {
    //   return (
    //     <div className='ui container cover'>
    //       <div className='coverContent mobile only'>
    //         <div>
    //           <WhenInView>
    //             {/* <iframe
    //               src='https://interaktiv.tagesanzeiger.ch/2018/schneetage/kugel-alle-mobile/snowfall_kugel_mobile.html'
    //               frameBorder='0'
    //               allowtransparency='true'
    //               allowFullScreen='allowfullscreen'
    //               webkitallowfullscreen='webkitallowfullscreen'
    //               mozallowfullscreen='mozallowfullscreen'
    //               oallowfullscreen='oallowfullscreen'
    //               msallowfullscreen='msallowfullscreen'
    //               width='100%'
    //               scrolling='no'
    //             /> */}

    //             <ImageSlider />
    //           </WhenInView>
    //         </div>
    //       </div>
    //     </div>
    //   )
    // }
  }
}
